import React from 'react';
import styled from 'styled-components';
import Ellipse from '@ey/canvascoreservices/Ellipse';

const Placeholder = (props) => {
	const {placeholderMessage, className, tooltipPlaceholder} = props;
	return (
		<StyledPlaceholder title={tooltipPlaceholder ? tooltipPlaceholder : placeholderMessage} className={className ? className : 'placeholder-message'}>
			{placeholderMessage && (
				<Ellipse content={placeholderMessage} tooltip={placeholderMessage} noOfLines={4} />
			)}
			{props.children && <span className="placeholder-content" title={tooltipPlaceholder ? tooltipPlaceholder : placeholderMessage}>
				{props.children}
			</span>}
			
			
		</StyledPlaceholder>
	);
};

export default Placeholder;

const StyledPlaceholder = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	// width: 70%;
	font-size: 1.4rem;
	span {
		margin-right: 0;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		// text-align: right;
		cursor: default;
		line-height: normal;
	}
	.servicerequest-detail {
		margin-right: 0;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		cursor: default;
	}
`;
